import { render, staticRenderFns } from "./MortgageApplicationSignItem.vue?vue&type=template&id=53964be8&scoped=true&"
import script from "./MortgageApplicationSignItem.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationSignItem.vue?vue&type=script&lang=js&"
import style0 from "./MortgageApplicationSignItem.vue?vue&type=style&index=0&id=53964be8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53964be8",
  null
  
)

export default component.exports